import React from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '@compiled/react';
import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { getSlug } from 'src/utils/slug';
import { generateArticleBreadcrumbItems } from 'src/utils/breadcrumbUtils';

import { ShareArticleButton } from './ShareArticleButton';

interface ArticleBreadcrumbsProps {
  articleData: {
    title: string;
    slug: string;
  };
}

export const ArticleBreadcrumbs: React.FC<ArticleBreadcrumbsProps> = ({ articleData }) => {
  const navigate = useNavigate();
  const articleSlug = getSlug(articleData);

  // Generate nested breadcrumb items
  const nestedItems = generateArticleBreadcrumbItems(articleSlug);

  return (
    <div css={breadcrumbsContainerStyles}>
      <Breadcrumbs itemsBeforeCollapse={0} itemsAfterCollapse={1}>
        <BreadcrumbsItem
          key="hub-resources-and-support-breadcrumb"
          text="Resources and Support"
          href="/hub/resources-and-support"
          onClick={(e) => {
            e.preventDefault();
            navigate('/hub/resources-and-support');
          }}
        />
        {/* Render nested breadcrumb items */}
        {nestedItems.map((item, index) => (
          <BreadcrumbsItem
            key={`${item.label}-${index}`}
            text={item.label}
            href={item.href}
            onClick={(e) => {
              e.preventDefault();
              navigate(item.href);
            }}
          />
        ))}
        {/* Final breadcrumb item (the article itself) */}
        <BreadcrumbsItem key={articleData.title} text={articleData.title} onClick={(e) => e.preventDefault()} />
      </Breadcrumbs>
      <div css={desktopShareArticleStyles}>
        <ShareArticleButton />
      </div>
    </div>
  );
};

const breadcrumbsContainerStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  '& ol li:last-child a': {
    textDecoration: 'none',
    cursor: 'default',
  },
});

const desktopShareArticleStyles = css({
  display: 'none',

  '@media (min-width: 1000px)': {
    display: 'block',
  },
});
